import React, { useState } from "react";
import { Button, Modal } from "antd";
import { DeleteOutlined} from "@ant-design/icons";
import { useMercuryContext } from "../../context";
import { failedNotification, successfulNotification } from "../../common/utils/notifications";

interface DeleteCurrencyProps {
  selectedRows: any;
  refresh: () => void;
  hasPermissions: boolean;
}

const DeleteCurrency: React.FC<DeleteCurrencyProps> = ({
  selectedRows,
   refresh,
   hasPermissions
}) => {
  const {gpClient}= useMercuryContext();
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const [visible, setVisible] = useState<boolean>(false);

  const handleOk = async () => {
    try {
      await gpClient.delete(`/core-v1/currency/${selectedRows[0]._id}`
      );

      setVisible(false);
      refresh();
      successfulNotification(
        "Success",
        `Currency '${selectedRows[0].name}' was successfully deleted.`
      );
    } catch (error: any) {
      console.error("Error deleting selected currency:", error);
      failedNotification(
        "Error",
        `Could not delete the selected currency. Please try again later.`
      );
    }
  };

  return (
    <>
      <Button icon={<DeleteOutlined />}
        type="primary"
        onClick={() => setVisible(true)}
        disabled={!hasPermissions}
        color={"var(--tertiary-color)"}
      >
        Delete
      </Button>
      <Modal
        mask={false}
        open={visible}
        title="Proceed and delete the following?"
        okText="Confirm and Delete"
        cancelText="Cancel"
        className="action-btn delete-btn"
        okType="danger"
        onCancel={() => {
          setVisible(false);
        }}
        onOk={async () => {
          try {
            setConfirmLoading(true);
            await handleOk();
          } catch (error) {
            console.log("Validate Failed:", error);
          } finally {
            setConfirmLoading(false);
          }
        }}
        confirmLoading={confirmLoading}
      >
        <p>
          Please confirm that you wish to delete the Currency: <br />
          <strong>'{selectedRows[0]?.name}'</strong>, this option cannot be
          undone.
        </p>
      </Modal>
    </>
  );
};

export default DeleteCurrency;